/** Whole numbers show without decimals (e.g. 1 not 1.00); fractional qty preserved. */
export function formatInvoiceQuantity(q) {
  const n = Number(q);
  if (Number.isNaN(n)) return '—';
  const r = Math.round(n);
  if (Math.abs(n - r) < 1e-9) return String(r);
  return String(n);
}

/** Paid plan only: active subscription, not free slug, price greater than 0 */
export function canForwardInvoiceByEmail(subscriptionPayload) {
  if (!subscriptionPayload?.has_active_subscription) return false;
  const sub = subscriptionPayload?.current_subscription;
  if (!sub) return false;
  const slug = String(sub.plan_slug || '').toLowerCase();
  const price = Number(sub.plan_price ?? 0);
  if (slug === 'free' || price <= 0) return false;
  return true;
}
